import { Filters as FiltersType } from '@/api/documents'
import { Flex } from '@/components'
import Filters from './Filters'
import SearchInput from './SearchInput'

type ActionBarProps = {
  setSearch: (search: string) => void
  applyFilters: (filters: FiltersType) => void
}

export const ActionBar = ({ setSearch, applyFilters }: ActionBarProps) => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Filters applyFilters={applyFilters} />
      <SearchInput setSearch={setSearch} />
    </Flex>
  )
}
